import { CSSProperties } from "react";
import { Loader, Circle } from "./styles";

interface ComponentProps {
  color?: "Primary" | "Secondary" | "White";
  style?: CSSProperties;
}

const Component = ({ color, ...rest }: ComponentProps) => {
  return (
    <Loader {...rest}>
      <Circle color={color}></Circle>
      <Circle color={color}></Circle>
      <Circle color={color}></Circle>
      <Circle color={color}></Circle>
    </Loader>
  );
};

export default Component;
